import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Grid                                from '@material-ui/core/Grid'
import Typography                          from '@material-ui/core/Typography'
import { InjectedFormikProps, withFormik } from 'formik'
import { object, ref }                     from 'yup'

import { Communication }            from '../../redux/ducks'
import { genArgConverter }          from '../../utils'
import {
  ActionButton, EnhancedTextField,
  InlineError,
  LoadingOverlay,
}                                   from '../atoms'
import {
  genValueMapper,
  i18nErrorCodes,
  mapFormikToMuiProps,
  proxyFormikSubmission,
}                                   from './form-utils'
import { passwordSchema }           from './schemas/formatSchemas'
import { FormikSubmissionCallBack } from './types'

export interface ChangePasswordFields {
  passwordCurrent: string
  passwordNew: string
  passwordConfirmation: string
}

interface ChangePasswordFormProps extends Communication {
  onSubmit: FormikSubmissionCallBack<ChangePasswordFields>
}

type Props = InjectedFormikProps<ChangePasswordFormProps, ChangePasswordFields>

class PasswordChangeForm extends React.Component<Props> {
  public componentDidUpdate (prevProps: Props) {
    if (
      !prevProps.success
      && this.props.success
    ) {
      this.props.resetForm()
    }
  }

  public render () {
    const { fetching, error } = this.props

    const mapper = mapFormikToMuiProps(this.props)

    return (
      <LoadingOverlay show={fetching}>
        <Typography variant={'title'} gutterBottom>
          <FormattedMessage id={'generic.changePassword'} />
        </Typography>
        <form onSubmit={this.submit}>
          <Grid container direction={'column'} spacing={16}>
            <Grid item>
              <EnhancedTextField
                fullWidth
                type={'password'}
                {...mapper('passwordCurrent')}
              />
            </Grid>
            <Grid item>
              <EnhancedTextField
                fullWidth
                type={'password'}
                {...mapper('passwordNew')}
              />
            </Grid>
            <Grid item>
              <EnhancedTextField
                fullWidth
                type={'password'}
                {...mapper('passwordConfirmation')}
              />
            </Grid>
            {error && (
              <Grid item>
                <InlineError i18nErrorId={error} />
              </Grid>
            )}
            <Grid item>
              <ActionButton
                actionType={'submit'}
                type={'submit'}
                variant={'raised'}
                color={'secondary'}
              />
            </Grid>
          </Grid>
        </form>
      </LoadingOverlay>
    )
  }

  private submit = (e: React.FormEvent<HTMLFormElement>) => {
    const { activeElement } = window.document
    if (activeElement && activeElement instanceof HTMLElement) {
      activeElement.blur()
    }

    this.props.handleSubmit(e)
  }
}

export const convertChangePassword = genArgConverter(
  ({
    passwordCurrent,
    passwordNew,
  }: ChangePasswordFields) => ({
    currentPassword: passwordCurrent,
    newPassword:     passwordNew,
  }))

const { mustBeIdentical, required } = i18nErrorCodes

export default withFormik<ChangePasswordFormProps, ChangePasswordFields>({
  mapPropsToValues: genValueMapper({
    passwordCurrent:      '',
    passwordNew:          '',
    passwordConfirmation: '',
  }),

  validationSchema: object().shape({
    passwordCurrent:      passwordSchema.required(required),
    passwordNew:          passwordSchema.required(required),
    passwordConfirmation: passwordSchema
                            .oneOf([ ref('passwordNew') ], mustBeIdentical)
                            .required(required),
  }),

  handleSubmit: proxyFormikSubmission,
})(PasswordChangeForm)



// WEBPACK FOOTER //
// ./src/components/forms/PasswordChangeForm.tsx